import { createSlice } from "@reduxjs/toolkit";

import {
    getAllLeadDestinationsAsync,
    getAllLeadDestinationTypesAsync,
} from "./leadDestinations.asyncActions";

const initialState = {
    getAllLeadDestinationTypes: {
        message: "",
        status: "idle",
        leadDestinations: [],
    },
    getAllLeadDestinations: {
        message: "",
        status: "idle",
        leadDestinations: [],
    },
};

export const leadDestinationsSlice = createSlice({
    name: "leadAllDestinationsState",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAllLeadDestinationTypesAsync.pending, (state) => {
                state.getAllLeadDestinationTypes.status = "loading";
            })
            .addCase(
                getAllLeadDestinationTypesAsync.fulfilled,
                (state, action) => {
                    state.getAllLeadDestinationTypes.status = "success";
                    state.getAllLeadDestinationTypes.leadDestinations =
                        action.payload.data && action.payload.data;
                    state.getAllLeadDestinationTypes.message =
                        action.payload.message && action.payload.message;
                },
            )
            .addCase(
                getAllLeadDestinationTypesAsync.rejected,
                (state, action) => {
                    state.getAllLeadDestinationTypes.status = "failed";
                    state.getAllLeadDestinationTypes.message =
                        action.payload.message && action.payload.message;
                },
            )
            .addCase(getAllLeadDestinationsAsync.pending, (state) => {
                state.getAllLeadDestinations.status = "loading";
            })
            .addCase(getAllLeadDestinationsAsync.fulfilled, (state, action) => {
                state.getAllLeadDestinations.status = "success";
                state.getAllLeadDestinations.leadDestinations =
                    action.payload.data && action.payload.data;
                state.getAllLeadDestinations.message =
                    action.payload.message && action.payload.message;
            })
            .addCase(getAllLeadDestinationsAsync.rejected, (state, action) => {
                state.getAllLeadDestinations.status = "failed";
                state.getAllLeadDestinations.message =
                    action.payload.message && action.payload.message;
            });
    },
});

export default leadDestinationsSlice.reducer;
